/* eslint-disable react-hooks/exhaustive-deps */
import React from //, { useState }
"react";
import {
  Tabel,
  Badge,
  Typography,
  // Loading
} from "../core";
import { theme } from "../styles";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const { textColor } = theme;

const YarnHistory = (props) => {
  let { yarnIssuence } = props;

  // const [isLoading, setIsLoading] = useState(false);

  const yarnRecieved = [
    {
      title: "Date",
      dataIndex: "yarnReceivedDate",
      key: "yarnReceivedDate",
      render: (text, record, index) => {
        return (
          <span>
            {CHANGE_DATE_FORMAT.changeDateFormat(record.yarnReceivedDate)}
          </span>
        );
      },
      width: 150,
    },
    {
      title: "Quality  (count/con_size/con_size/brand)",
      dataIndex: "yarnReceivedQuality",

      key: "yarnReceivedQuality",
      width: 150,
    },
    {
      title: "Do #",
      dataIndex: "DoNo",
      key: "DoNo",
      width: 150,
    },
    {
      title: "Variation",
      dataIndex: "yarnReceivedQuantity",
      key: "yarnReceivedQuantity",
      children: [
        {
          title: "Yarn for",
          dataIndex: "yarnReciedFor",
          key: "yarnReciedFor",
          render: (text, record, index) => (
            <span>
              {/* {record.yarnReceivedQuantity &&
                record.yarnReceivedQuantity.map(({ yarnReciedFor }) => (
                  <div>{yarnReciedFor}</div>
                ))} */}
              {record.yarnReceivedQuantity &&
                record.yarnReceivedQuantity.map(({ yarnReciedFor }) => (
                  <div>{yarnReciedFor}</div>
                ))}
            </span>
          ),
          width: 150,
        },
        {
          title: "Bags",
          dataIndex: "bag",
          key: "bag",
          render: (text, record, index) => (
            <span>
              {record.yarnReceivedQuantity &&
                record.yarnReceivedQuantity.map(({ bag }) => <div>{bag}</div>)}
              {/* {record.yarnReceivedQuantity &&
                record.yarnReceivedQuantity.map(({ bag }) => <div>{bag}</div>)} */}
            </span>
          ),
          width: 150,
        },
        {
          title: "Cons",
          dataIndex: "cons",
          key: "cons",
          render: (text, record, index) => (
            <span>
              {record.yarnReceivedQuantity &&
                record.yarnReceivedQuantity.map(({ cons }) => (
                  <div>{cons}</div>
                ))}
              {/* {record.yarnReceivedQuantity &&
                record.yarnReceivedQuantity.map(({ cons }) => (
                  <div>{cons}</div>
                ))} */}
            </span>
          ),
          width: 150,
        },
      ],
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (text) => <Badge status={text} text={text} />,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 150,
      render: (text, record, index) => (
        <span>menu</span>
        // <DropDown
        //   overlay={<MenuCompo index={index} record={record} />}
        //   record={record}
        // />
      ),
    },
  ];

  return (
    <div>
      {console.log("yarnIssuence", yarnIssuence)}
      {/* {isLoading && <Loading />} */}
      <Typography
        as="h3"
        weight="bold"
        letterSpacing="0.2px"
        color={textColor.primary}
        text="Yarn History"
      />
      <Tabel
        pagination={false}
        columns={yarnRecieved}
        data={yarnIssuence}
        rowKey={({ id }) => id}
      />
      {/* <Row gutter={[32, 32]} className="mt-20" type="flex" justify="between">
        <Col md={12} xs={24}>
          <Tabel
            pagination={false}
            columns={yarnRecieved}
            data={[]}
            rowKey={({ id }) => id}
          />
        </Col>
        <Col md={12} xs={24}>
          <Tabel
            pagination={false}
            columns={yarnRecieved}
            data={[]}
            rowKey={({ id }) => id}
          />
        </Col>
      </Row> */}
    </div>
  );
};

export default YarnHistory;
